import Chat from './components/Chat'

let Components = {
  Chat
}

export default Components
